import {Component, DestroyRef, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzSpinModule} from 'ng-zorro-antd/spin';
import {TranslateService} from '@ngx-translate/core';
import {PolicyService} from '../../core/services/policy.service';
import {PolicyDocument} from '../../shared/policy/policy-document';
import {PolicyView} from '../../shared/policy/policy-view';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [
    NzCardModule,
    NzSpinModule,
    PolicyView,
  ],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.css',
})
export class PrivacyPolicy {
  private readonly policyService = inject(PolicyService);
  private readonly translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  readonly document = signal<PolicyDocument | null>(null);

  constructor() {
    this.load();
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.load());
  }

  private load(): void {
    this.policyService.load()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(document => this.document.set(document));
  }
}
